import { throttle } from 'lodash-es'
export const isVideo = path => {
  return /\.(mp4|avi|wmv|mpg|mpeg|mov|rm|ram|swf|flv)$/i.test(path)
}

export const generateVideoPoster = src =>
  `${src}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto`

export const isImage = path => {
  return /\.(jpg|jpeg|png|gif|svg|webp|avif|jp)$/i.test(path)
}

export const isGif = path => {
  return /\.gif$/i.test(path)
}
export const isCR3 = path => {
  return /\.(CR3|cr3})$/i.test(path)
}

export const evalPropChain = (data, fieldChain) => {
  return new Function('obj', 'with(obj){return ' + fieldChain + ';}')(data)
}
export const observeDomResize = (node, callback, throttleTime = 300) => {
  const _callback = throttle(callback, throttleTime)
  const observer = new ResizeObserver(_callback)
  if (node && node instanceof Element) {
    observer.observe(node)
  } else {
    console.warn('Invalid element for ResizeObserver:', node)
  }
  return observer
}

/**
 * 只保留有用的key
 * @param {*} obj
 * @param {有用的keys} arr
 * @returns
 */
export const omitObjectKey = (obj, arr) =>
  Object.keys(obj)
    .filter(k => arr.includes(k))
    .reduce((acc, key) => ((acc[key] = obj[key]), acc), {})
export const insertHtmlResourceJs = arr => {
  arr.forEach(element => {
    const script = document.createElement('script')
    script.type = element.type || 'module'
    script.dataset.moduleId = element.id
    script.src = element.src
    document.head.appendChild(script)
  })
}
export const insertHtmlResourceCss = arr => {
  arr.forEach(element => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.dataset.moduleId = element.id
    link.href = element.href
    document.head.appendChild(link)
  })
}
export const insertHtmlResourceFont = arr => {
  arr.forEach(element => {
    const link = document.createElement('link')
    link.rel = 'preload'
    link.crossorigin = 'anonymous'
    link.as = 'font'
    link.type = element.type || 'font/woff2'
    link.dataset.moduleId = element.id
    link.href = element.href
    document.head.appendChild(link)
  })
}
export const isNumber = val => {
  return parseFloat(val) !== 'NaN'
}
export const isStringEmpty = str => {
  return str === null || str === undefined || str === ''
}
export function translateDataToTree(data) {
  console.time('sd')
  console.log('sd')
  const parents = data.filter(
    value => value.parentId === 'undefined' || value.parentId == null
  )
  const children = data.filter(
    value => value.parentId !== 'undefined' && value.parentId != null
  )
  const translator = (parents, children) => {
    parents.forEach(parent => {
      parent.title = parent.name
      parent.value = parent.id
      children.forEach((current, index) => {
        if (current.parentId === parent.id) {
          const temp = JSON.parse(JSON.stringify(children))
          temp.splice(index, 1)
          translator([current], temp)
          typeof parent.children !== 'undefined'
            ? parent.children.push(current)
            : (parent.children = [current])
        }
      })
    })
  }
  translator(parents, children)
  console.log(parents)
  console.timeEnd('sd')

  return parents
}
